var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 13.9c-3.6 0-7.3-2.1-10.8-6.4l-.1-.6.1-.7c7-8.4 14.5-8.4 21.5 0l.2.6-.2.6c-3.4 4.4-7.1 6.5-10.7 6.5zm-8.7-7c5.9 6.6 11.5 6.6 17.4 0C13.8.3 8.2.3 2.3 6.9z","key":0}),React.createElement("circle",{"cx":"11","cy":"7","r":"3","key":1})]);
}

Eye.defaultProps = {"width":"22","height":"14","viewBox":"0 0 22 14"};

module.exports = Eye;

Eye.default = Eye;
